import { useEffect } from 'react';

/**
 * Names the page in the tab title, e.g. "Log In | Aperio" (QA 2026-09-25
 * #31, WCAG 2.4.2): every auth page used to share "Book Online | <brand>".
 * The brand is whatever the head already carries after its last " | " (the
 * tenant's own, set by bootTheme / the language switch), so no tenant's
 * brand is re-derived here. The previous title comes back on the way out.
 */
export default function usePageTitle(page: string) {
  useEffect(() => {
    if (typeof document === 'undefined' || !page) return undefined;
    const previous = document.title;
    const cut = previous.lastIndexOf(' | ');
    const brand = cut >= 0 ? previous.slice(cut + 3) : previous;
    document.title = brand ? `${page} | ${brand}` : page;
    return () => {
      document.title = previous;
    };
  }, [page]);
}
